const actionNames = {
  SHOW_SETTINGS_VIEW: 'SHOW_SETTINGS_VIEW',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',

  GET_USER_SETTINGS_REQUESTED: 'GET_USER_SETTINGS_REQUESTED',
  GET_USER_SETTINGS_SUCCEEDED: 'GET_USER_SETTINGS_SUCCEEDED',
  GET_USER_SETTINGS_FAILED: 'GET_USER_SETTINGS_FAILED',

  UPDATE_USER_SETTINGS_REQUESTED: 'UPDATE_USER_SETTINGS_REQUESTED',
  UPDATE_USER_SETTINGS_SUCCEEDED: 'UPDATE_USER_SETTINGS_SUCCEEDED',
  UPDATE_USER_SETTINGS_FAILED: 'UPDATE_USER_SETTINGS_FAILED',

  GET_PROFILE_REQUESTED: 'GET_PROFILE_REQUESTED',
  GET_PROFILE_SUCCEEDED: 'GET_PROFILE_SUCCEEDED',
  GET_PROFILE_FAILED: 'GET_PROFILE_FAILED',

  UPDATE_PROFILE_REQUESTED: 'UPDATE_PROFILE_REQUESTED',
  UPDATE_PROFILE_SUCCEEDED: 'UPDATE_PROFILE_SUCCEEDED',
  UPDATE_PROFILE_FAILED: 'UPDATE_PROFILE_FAILED',

  GET_PREFERENCES_REQUESTED: 'GET_PREFERENCES_REQUESTED',
  GET_PREFERENCES_SUCCEEDED: 'GET_PREFERENCES_SUCCEEDED',
  GET_PREFERENCES_FAILED: 'GET_PREFERENCES_FAILED',

  UPDATE_PREFERENCES_REQUESTED: 'UPDATE_PREFERENCES_REQUESTED',
  UPDATE_PREFERENCES_SUCCEEDED: 'UPDATE_PREFERENCES_SUCCEEDED',
  UPDATE_PREFERENCES_FAILED: 'UPDATE_PREFERENCES_FAILED',

  GET_NOTIFICATIONS_REQUESTED: 'GET_NOTIFICATIONS_REQUESTED',
  GET_NOTIFICATIONS_SUCCEEDED: 'GET_NOTIFICATIONS_SUCCEEDED',
  GET_NOTIFICATIONS_FAILED: 'GET_NOTIFICATIONS_FAILED',

  UPDATE_NOTIFICATIONS_REQUESTED: 'UPDATE_NOTIFICATIONS_REQUESTED',
  UPDATE_NOTIFICATIONS_SUCCEEDED: 'UPDATE_NOTIFICATIONS_SUCCEEDED',
  UPDATE_NOTIFICATIONS_FAILED: 'UPDATE_NOTIFICATIONS_FAILED',

  GET_SECURITY_REQUESTED: 'GET_SECURITY_REQUESTED',
  GET_SECURITY_SUCCEEDED: 'GET_SECURITY_SUCCEEDED',
  GET_SECURITY_FAILED: 'GET_SECURITY_FAILED',

  UPDATE_SECURITY_REQUESTED: 'UPDATE_SECURITY_REQUESTED',
  UPDATE_SECURITY_SUCCEEDED: 'UPDATE_SECURITY_SUCCEEDED',
  UPDATE_SECURITY_FAILED: 'UPDATE_SECURITY_FAILED',

  RESET_SETTINGS_REQUESTED: 'RESET_SETTINGS_REQUESTED',
  RESET_SETTINGS_SUCCEEDED: 'RESET_SETTINGS_SUCCEEDED',
  RESET_SETTINGS_FAILED: 'RESET_SETTINGS_FAILED',

  EXPORT_SETTINGS_REQUESTED: 'EXPORT_SETTINGS_REQUESTED',
  EXPORT_SETTINGS_SUCCEEDED: 'EXPORT_SETTINGS_SUCCEEDED',
  EXPORT_SETTINGS_FAILED: 'EXPORT_SETTINGS_FAILED',

  IMPORT_SETTINGS_REQUESTED: 'IMPORT_SETTINGS_REQUESTED',
  IMPORT_SETTINGS_SUCCEEDED: 'IMPORT_SETTINGS_SUCCEEDED',
  IMPORT_SETTINGS_FAILED: 'IMPORT_SETTINGS_FAILED',
}

export default actionNames
